module.exports = __webpack_public_path__ + "h5-static/img/icon_kong_youhuiquan@3x.6037e92d.png";